import { useTranslation } from '@eti/providers';
import { css, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { dataCellStyles } from '../utils/summaryStyles';
import { jsx as _jsx } from "react/jsx-runtime";
const cellStyles = css`
  ${dataCellStyles};

  @media (max-width: 47.9375em) {
    display: block;
    margin-left: 36px;
    max-width: 43%;

    html[dir='rtl'] & {
      margin-left: 0;
      margin-right: 36px;
    }
  }
`;
const wrapperStyles = css`
  display: flex;
`;
const notSelectedIconStyles = css`
  fill: ${etiColors.warning.solid};
  flex-shrink: 0;
  height: 0.75rem;
  margin-right: 0.375rem;
  position: relative;
  top: 2px;
  width: 0.75rem;

  html[dir='rtl'] & {
    margin-left: 0.375rem;
    margin-right: 0;
  }

  @media (min-width: 48em) {
    height: 0.9375rem;
    width: 0.9375rem;
  }
`;
const labelStyle = css`
  margin-right: 3px;
`;
const SelectedSeatCell = _ref => {
  let {
    selectedSeat
  } = _ref;
  const {
    t
  } = useTranslation();
  const notSelectedLabel = t('Product.SeatMap.Summary.Seat.NotSelected');
  const label = t('Product.SeatMap.Seat');
  return /*#__PURE__*/_jsx("td", {
    className: cellStyles,
    children: /*#__PURE__*/_jsx("div", {
      className: wrapperStyles,
      children: selectedSeat ? [/*#__PURE__*/_jsx("span", {
        className: labelStyle,
        children: label
      }, "selectedSeat"), selectedSeat] : [/*#__PURE__*/_jsx(Icon, {
        className: notSelectedIconStyles,
        id: "exclamation-circle"
      }, "notSelectedSeat"), notSelectedLabel]
    })
  });
};
export default SelectedSeatCell;
//# sourceMappingURL=SummarySelectedSeatCell.js.map